module.exports = __webpack_public_path__ + "img/exchange-result.5349e332.svg";